import {
    FETCH_AGGREGATE_RESULTS_REQUEST,
    FETCH_AGGREGATE_RESULTS_SUCCESS,
    FETCH_AGGREGATE_RESULTS_FAILURE,
} from './types/aggregate-results-action-types';

import MimirService from '../services/mimir-service';
import {
    canvasByIdSelector
} from '../../dashboard/selectors/canvas-selectors';
import {
    aggResultsParamsSelector,
} from '../selectors/aggregate-results-selectors';

import {
    isEqual
} from 'lodash';

function fetchAggResultsRequest( params = {} ){
    return {
        params,
        type: FETCH_AGGREGATE_RESULTS_REQUEST,
    };
}

function fetchAggResultsSuccess( response ){
    return {
        type: FETCH_AGGREGATE_RESULTS_SUCCESS,
        ...response
    };
}

function fetchAggResultsFailure( error ){
    return {
        error,
        type: FETCH_AGGREGATE_RESULTS_FAILURE,
    };
}

function fetchAggResults( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchAggResultsRequest( params ) );
        const api = new MimirService( DATA_API );

        return api.getAggregateData( params ).then(
            ( response ) => dispatch( fetchAggResultsSuccess( response ) ),
            ( error ) => dispatch( fetchAggResultsFailure( error ) )
        );
    };
}

export function fetchAggResultsIfNeeded( params ){
    return ( dispatch, getState ) => {
        const store = getState();
        const aggResultsParams = aggResultsParamsSelector( store );

        if( !isEqual( params, aggResultsParams ) ){
            return dispatch( fetchAggResults( params ) );
        }
        else{
            return Promise.resolve();
        }
    };
}

export function refreshAggResults(){
    return ( dispatch, getState ) => {
        const store = getState();
        const params = aggResultsParamsSelector( store );

        return dispatch( fetchAggResults( params ) );
    };
}

export function fetchAggResultsByCanvasId( canvasId ){
    return ( dispatch, getState ) => {
        const canvasParams = canvasByIdSelector( getState() )[canvasId].params;

        return dispatch( fetchAggResultsIfNeeded( canvasParams ) );
    };
}
